import type { ProviderConfigSectionProps } from './types';

export function R2ConfigSection(_props: ProviderConfigSectionProps) {
  return null;
}
